import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarServicedesk from '@atlassian/jira-navigation-apps-sidebar-servicedesk/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getQueuesResources } from '@atlassian/jira-router-resources-service-desk-common/src/index.tsx';
import { servicedeskPracticeManageViewRoute } from '@atlassian/jira-router-routes-servicedesk-queues-routes/src/servicedeskPracticeManageViewRoute.tsx';
import { serviceProjectLayout } from '@atlassian/jira-service-project-layout/src/index.tsx';
import ServicedeskQueuesManageView, {
	LazyServicedeskQueuesManageView,
} from './ui/manage-view/index.tsx';

export const servicedeskPracticeManageViewRouteEntry = createEntry(
	servicedeskPracticeManageViewRoute,
	() => ({
		group: 'servicedesk',
		component: ServicedeskQueuesManageView,
		layout: serviceProjectLayout,

		navigation: {
			menuId: MENU_ID.PROJECTS,
			sidebar: AsyncSidebarServicedesk,
		},

		resources: getQueuesResources(),
		forPaint: [LazyAtlassianNavigation, LazyServicedeskQueuesManageView],

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-servicedesk-queues-entries/src/servicedeskPracticeManageViewRouteEntry.tsx',
				whichExportToUse: 'servicedeskPracticeManageViewRouteEntry',
			},

			enabled: true,
		},
	}),
);
